// Define valid environments as a strict enum rather than type
enum Environment {
  DEV = 'dev',
  MAIN = 'main',
  STAGING = 'staging',
}

const DEV_API_ROOT_LOCAL = 'http://localhost:8080';
const DEV_API_ROOT_DEPLOYED = 'https://dev-api.welovealfa.com';

const useLocalApi = process.env.NEXT_PUBLIC_LOCAL_API === 'true';

const API_ROOTS: Readonly<Record<Environment, string>> = Object.freeze({
  [Environment.DEV]: useLocalApi ? DEV_API_ROOT_LOCAL : DEV_API_ROOT_DEPLOYED,
  [Environment.MAIN]: 'https://api.welovealfa.com',
  [Environment.STAGING]: 'https://staging-api.welovealfa.com',
});

function getValidatedEnvironment(): Environment {
  const isProd = process.env.NEXT_PUBLIC_STAGE === 'main' || process.env.STAGE === 'main';

  const isStaging = process.env.NEXT_PUBLIC_STAGE === 'staging' || process.env.STAGE === 'staging';

  if (isProd) {
    return Environment.MAIN;
  }

  if (isStaging) {
    return Environment.STAGING;
  }

  return Environment.DEV;
}

// Get validated API root
export const apiRoot: string = API_ROOTS[getValidatedEnvironment()];

// Prevent modifications to the API roots object
Object.freeze(apiRoot);

export default apiRoot;
